<script setup lang="ts">
import DownArrow from '@/components/standardComponents/iconComponent/DownArrowIcon.vue';

const emits = defineEmits<{ click: [] }>();
</script>

<template>
    <div class="expand_btn" @click="emits('click')">
        <div class="text">Expand</div>
        <DownArrow class="icon" />
    </div>
</template>

<style lang="scss" scoped>
@use './ExpandBtn.scss';
</style>
